'use client';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

import { AUTH_PROVIDERS } from '@/models';

import { ProviderButton } from './components';

export default function SignInPage() {
  return (
    <Suspense>
      <SignInContent />
    </Suspense>
  );
}

function SignInContent() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') ?? '/';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2 }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            p: 4,
          }}
        >
          <Typography variant="h5" component="h1">
            Cockpit Business
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: 'center' }}
          >
            Connectez-vous pour accéder à l&apos;application
          </Typography>
          {Object.values(AUTH_PROVIDERS).map((provider) => (
            <ProviderButton
              key={provider.name}
              provider={provider}
              callbackUrl={callbackUrl}
            />
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}
